/* global angular:false */
(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutDisclaimerController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            $scope.Control.Identifier = $element.closest('.js-control-root').data('identifier');
            var controlName = 'Disclaimer' + $scope.Control.Identifier;
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.IsValid = true;
            $scope.Control.Form = {
                TermsAccepted: false,
                PrivacyPolicyAccepted: false
            };
            $scope.setControlValue(controlName, $scope.Control.Form);

            $scope.Control.getId = function () {
                return 'chk' + controlName;
            };


            var initiallyValidated = false;

            $element.get(0).validate = function (onComplete) {
                $scope.Control.IsValid = true;
                $scope.Control.Form.TermsAcceptedError = false;

                if (!$scope.Control.Form.TermsAccepted) {
                    $scope.Control.IsValid = false;
                    $scope.Control.Form.TermsAcceptedError = true;
                }
                if (typeof (onComplete) === 'function') {
                    setTimeout(function () {
                        onComplete($scope.Control.IsValid);
                    }, 200);
                }

                initiallyValidated = true;
            };

            ControlService.getCheckoutData("GetDisclaimerData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);
                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });
        });

})();